export const PRICE_TEST_ID = "price-test-id";
export const PRICE_SVG_MASK_TEST_ID = "price-svg-mask-test-id";
export const MIN_WIDTH_SVG_ELEMENT = 14;
export const PRICE_SVG_MASK_DISPLAY_NAME = "Price.SvgMask";
export const PRICE_DISPLAY_NAME = "Price";
export const PRICE_WRAPPER_STATE_ENABLED = "price-wrapper__state-enabled";
export const PRICE_WRAPPER_STATE_NONE = "price-wrapper__state-none";
export const PRICE_INNER_STATE_ENABLED = "price-inner__state-enabled";
export const PRICE_INNER_STATE_NONE = "price-inner__state-none";
export const PRICE_TEST_LABEL = "10 ОК";
export const PRICE_ANIMATION = "price__animation";
